import React from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Divider,
  Grid,
  Link,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { DataGrid, GridColDef, GridRenderCellParams, GridToolbar } from "@mui/x-data-grid";

import { format } from "date-fns";
import { IPurchaseOrderWithDetails } from "../../../api/Account/myOrdersApi";
import { myPurchasesResources } from "./.resources";
import { useResources } from "../../../hooks/useResources";
import { IUserV0 } from "../../../api/Account/usersApi";
import * as urls from "../../../types/Constants";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

//https://devexpress.github.io/devextreme-reactive/react/grid/demos/featured/tree-data/

export interface IPurchaseOrderRow extends IPurchaseOrderWithDetails {
  id: string;
  ownerName?: string;
  ownerCompany?: string;
  endUserName?: string;
  endUserCompany?: string;
  singleProductOrder: string;
  index: number;
  hasChildren: boolean;
  parentId?: string;
}

export interface IMyPurchasesGridProps {
  orders: IPurchaseOrderRow[];
  user: IUserV0;
  treeView: boolean;
  handleGoToUrl: (msg: string) => void;
  //handleNotification: (msg: string | null | undefined) => void;
}

const MyPurchasesGrid: React.FC<IMyPurchasesGridProps> = ({
  orders,
  user,
  handleGoToUrl,
}) => {
  // Language sync is handled globally in App.tsx
  const res = useResources(myPurchasesResources);

  const columnsCustomer: GridColDef[] = [
    {
      field: "orderId",
      headerName: res.orderId,
      width: 400,
      renderCell: (params: GridRenderCellParams) => {
        const row = params.row;
        return (
          <div className={styles.acordionContainer}>
            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Grid container direction="column">
                  <Typography variant="h5">{row.orderId}</Typography>
                  <Typography variant="body2">
                    {row.date ? format(new Date(row.date), "dd/MM/yyyy") : ""}
                  </Typography>
                </Grid>
              </AccordionSummary>
              <AccordionDetails>
                <div>
                  <Grid container direction="row" alignItems="center">
                  {row.details.map((program) => {
                    const productUrl = urls.getMyDownloads(
                      row?.endUserId || "",
                      program.programId
                    );
                    const licensesUrl = urls.getProjectLicensesUrl(
                      program.programId,
                      program.productId,
                      row.endUserId,
                      program.productName
                    );
                    return (
                      <>
                        <Grid size={{ xs: 4 }}>
                          <Typography variant="body1" style={{ marginRight: 12 }}>
                            {res.product}
                          </Typography>
                        </Grid>
                        <Grid size={{ xs: 8 }}>
                          <Link
                            key={productUrl}
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              handleGoToUrl(productUrl);
                            }}
                            className={styles.productLink}
                            color="primary"
                          >
                            {program.productName}
                          </Link>
                        </Grid>
                        <Grid size={{ xs: 4 }}>
                          <Typography variant="body1" style={{ marginRight: 12 }}>
                            {res.licenses}
                          </Typography>
                        </Grid>
                        <Grid size={{ xs: 8 }}>
                          <Link
                            key={licensesUrl}
                            href={licensesUrl}
                            color="primary"
                            onClick={(e) => {
                              e.preventDefault();
                              handleGoToUrl(licensesUrl);
                            }}
                          >
                            {res.showLicenses}
                          </Link>
                        </Grid>
                      </>
                    );
                  })}
                  </Grid>
                </div>
              </AccordionDetails>
            </Accordion>
          </div>
        );
      },
    },
    { field: "date", headerName: res.date, width: 150 },
    { field: "singleProductOrder", headerName: res.product, width: 300 },
  ];

  const columnsDist: GridColDef[] = [
    {
      field: "orderId",
      headerName: res.orderId,
      width: 400,
      renderCell: (params: GridRenderCellParams) => {
        const row = params.row;
        return (
          <div className={styles.acordionContainer}>
            <Accordion>
              <AccordionSummary
                style={{ width: "100%" }}
                expandIcon={<ExpandMoreIcon />}
              >
                <Grid container direction="column" className={styles.companyText}>
                  <Typography variant="h6">{row.orderId}</Typography>
                  <Typography variant="caption">{row.endUserCompany}</Typography>
                </Grid>
              </AccordionSummary>
              <AccordionDetails>
                <div></div>
                <Divider />
                <Grid container direction="column">
                  <div>
                    <Grid container direction="row" alignItems="center">
                    <Grid size={{ xs: 4 }}>
                      <Typography variant="body1" style={{ marginRight: 12 }}>
                        {res.date}
                      </Typography>
                    </Grid>
                    <Grid size={{ xs: 8 }}>
                      <Typography variant="body2">
                        {row.date ? format(new Date(row.date), "dd/MM/yyyy") : ""}
                      </Typography>
                    </Grid>
                    <Grid size={{ xs: 4 }}>
                      <Typography variant="body1" style={{ marginRight: 12 }}>
                        {res.customerName}
                      </Typography>
                    </Grid>
                    <Grid size={{ xs: 8 }}>
                      <Typography variant="body2">{row.endUserName}</Typography>
                    </Grid>

                    {row.details.map((program) => {
                      const productUrl = urls.getMyDownloads(
                        row?.endUserId || "",
                        program.programId
                      );
                      const licensesUrl = urls.getProjectLicensesUrl(
                        program.programId,
                        program.productId,
                        row.endUserId,
                        program.productName
                      );
                      return (
                        <>
                          <Grid size={{ xs: 4 }}>
                            <Typography variant="body1" style={{ marginRight: 12 }}>
                              {res.product}
                            </Typography>
                          </Grid>
                          <Grid size={{ xs: 8 }}>
                            <Link
                              key={productUrl}
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                handleGoToUrl(productUrl);
                              }}
                              className={styles.productLink}
                              color="primary"
                            >
                              {program.productName}
                            </Link>
                          </Grid>
                          <Grid size={{ xs: 4 }}>
                            <Typography variant="body1" style={{ marginRight: 12 }}>
                              {res.licenses}
                            </Typography>
                          </Grid>
                          <Grid size={{ xs: 8 }}>
                            <Link
                              key={licensesUrl}
                              href={licensesUrl}
                              color="primary"
                              onClick={(e) => {
                                e.preventDefault();
                                handleGoToUrl(licensesUrl);
                              }}
                            >
                              {res.showLicenses}
                            </Link>
                          </Grid>
                        </>
                      );
                    })}
                    </Grid>
                  </div>
                </Grid>
              </AccordionDetails>
            </Accordion>
          </div>
        );
      },
    },
    { field: "date", headerName: res.date, width: 150 },
    { field: "endUserName", headerName: res.customerName, width: 250 },
    { field: "endUserCompany", headerName: res.companyName, width: 300 },
    { field: "ownerName", headerName: res.representedBy, width: 250 },
    { field: "singleProductOrder", headerName: res.product, width: 340 },
    { field: "licenses", headerName: "", width: 100 },
  ];

  const useStyles = makeStyles(() => ({
    acordionContainer: {
      width: "100%",
      margin: 0,
      padding: 0,
    },
    productLink: {
      wordWrap: "break-word",
      whiteSpace: "normal",
      textAlign: "center",
      width: "100%",
      height: "auto",
      margin: "12px 0 12px 0",
    },
    companyText: {
      wordWrap: "break-word",
      whiteSpace: "normal",
      maxWidth: "100%",
    },
  }));
  const styles = useStyles();


  const renderColumns = () => {
    if (user?.isCustomer) {
      return columnsCustomer;
    }
    return columnsDist;
  };

  return (
    <div id="my-purchases-list" style={{ height: 600, width: '100%' }}>
      <DataGrid
        rows={orders}
        columns={renderColumns()}
        getRowId={(row) => row.id || row.orderId || Math.random()}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 25 }
          },
          columns: {
            columnVisibilityModel: {
              date: user?.isCustomer !== true,
              singleProductOrder: user?.isCustomer !== true,
              endUserCompany: user?.isCustomer !== true,
              endUserName: user?.isCustomer !== true,
              ownerName: user?.isCustomer !== true,
              licenses: user?.isCustomer !== true
            }
          }
        }}
        slots={{ toolbar: GridToolbar }}
        slotProps={{
          toolbar: {
            showQuickFilter: true,
            quickFilterProps: { debounceMs: 500 }
          }
        }}
        pageSizeOptions={[10, 25, 50, 100]}
        checkboxSelection={false}
        disableRowSelectionOnClick
        rowHeight={200}
      />
    </div>
  );
};

export default MyPurchasesGrid;
